export const OPTIONAL_SYMBOL: unique symbol = Symbol('optionalRelation');

export type OptionalRelation<T extends object = Record<never, never>> = T & {
  readonly [OPTIONAL_SYMBOL]: true;
};

export type IsOptional<T> = typeof OPTIONAL_SYMBOL extends keyof T ? true : false;

/**
 * This is a marker function to build typed queries with optional relations. It does not do anything at runtime, but it allows us to type the query correctly.
 * see also: libs/shared/types/src/lib/types/entity-with-relations.type.ts.
 */
export const optional = <T extends object = Record<never, never>>(subQuery?: T): OptionalRelation<T> =>
  ({ ...(subQuery ?? {}), [OPTIONAL_SYMBOL]: true }) as OptionalRelation<T>;
